import React, {} from 'react';
import "./styles.scss";
import { HadithTable } from '../../components/tables/HadithTable/HadithTable';

export const Hadiths = () => {

  return (
    <div className='data-table'>
      <HadithTable />
    </div>
  );
};